import { useContext, useEffect, useState } from 'react';
import { categories, errorColor, successColor } from './constants';
import styles from './style.module.scss';
import { Select, FormControl, InputLabel, MenuItem, TextField, Button } from '@material-ui/core';
import { fetchMarginUploads, uploadFile, uploadMargin } from './indexApi';
import MarginTable from './marginTable';
import AlertComponent from '../../components/AlertComponent';
import { Context as AuthContext } from '../../context/AuthContext';

const MarginUpload = () => {
  const { state } = useContext(AuthContext);
  const userId = state?.userData?.user_id;
  const sellerId = state?.userData?.seller_id;
  const [marginUploadData, setMarginUploadData] = useState([]);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [loader, setLoader] = useState(true);
  const [file, setFile] = useState();
  const [marginType, setMarginType] = useState('CATEGORY');
  const [startDatetime, setStartDatetime] = useState('');
  const [endDatetime, setEndDatetime] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [reqObj, setReqObj] = useState({
    page: 1,
    size: 15,
  })

  async function getMarginUploadList() {
    setLoader(true);
    let obj = {
      size: reqObj.size,
      page: reqObj.page
    }
    try {
      let response = await fetchMarginUploads(obj);
      if (response && response.data && response.data.message === "success") {
        setMarginUploadData(response?.data?.data?.margins);
        setTotalPageCount(Math.ceil(response?.data?.data?.totalCount / reqObj.size));
        setLoader(false);
      }
    } catch (err) {
      console.error(err);;
    }
  }
  const setAlertFnc = (msg, type, show) => {
    setShowAlert(show);
    setAlertObj({ msg: msg, color: type })
  }
  const [alertObj, setAlertObj] = useState({
    msg: null,
    color: null
  })

  function formatDate(value) {
    const inputDate = new Date(value);
    const formattedDate = `${inputDate.getUTCFullYear()}-${(inputDate.getUTCMonth() + 1).toString().padStart(2, '0')}-${inputDate.getUTCDate().toString().padStart(2, '0')} ${inputDate.getUTCHours().toString().padStart(2, '0')}:${inputDate.getUTCMinutes().toString().padStart(2, '0')}:${inputDate.getUTCSeconds().toString().padStart(2, '0')}`;
    return formattedDate;
  }

  async function uploadMarginFile() {
    const diff = new Date(endDatetime) - new Date(startDatetime);
    const daysDifference = diff / (1000 * 60 * 60 * 24);
    if (daysDifference > 10) {
      const msg = `Difference between Start datetime and End datetime shouldn't exceed 10 days`;
      setAlertFnc(msg, errorColor, true);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    let url = '';
    try {
      const response = await uploadFile(formData);
      if (response && response?.data && response?.data?.message === "success") {
        url = response?.data?.data?.marginSheetUrl;
      }
    } catch (err) {
      console.error(err);
    }
    const payload = {
      sheetUrl: url,
      marginType,
      startDatetime: formatDate(startDatetime),
      endDatetime: formatDate(endDatetime),
      createdBy: userId,
    };
    try {
      const resp = await uploadMargin(payload);
      if (resp && resp?.data && resp?.data?.message === "success") {
        let msg = `Margin Uploaded successfully`
        setAlertFnc(msg, successColor, true);
        setStartDatetime('');
        setEndDatetime('');
        getMarginUploadList();
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    getMarginUploadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqObj]);

  const handlePageChange = (type) => {
    let obj = { ...reqObj };
    if (type === 'Next') {
      obj.page++;
    }
    else {
      obj.page--;
    }
    setReqObj(obj);
  }

  if (parseInt(sellerId) !== 24346) {
    return (
      <div className={styles.notAuth}>Not Authorized</div>
    )
  }

  return (
    <div className={styles?.mainContainer}>
      <AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
      <h5>Margin Upload</h5>
      <div className={styles?.box}>
        <FormControl variant="filled" className={styles?.selectItem}>
          <InputLabel id="category">Type</InputLabel>
          <Select
            labelId="category"
            id="category"
            value={marginType}
            onChange={(e) => setMarginType(e.target.value)}
          >
            {
              categories?.map((cat) => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)
            }
          </Select>
        </FormControl>
        <input
          accept=".csv"
          className={styles?.input}
          id="contained-button-file"
          type="file"
          onChange={(e) => {
            setFile(e?.target?.files[0]);
          }}
        />
        <label htmlFor="contained-button-file">
          <Button variant="outlined" component="span" color="primary">
            Upload Sheet
          </Button>
          <p>{file && file?.name}</p>
        </label>
      </div>
      <div className={styles.box}>
        <form>
          <TextField
            id="datetime-local"
            label="Start Date & Time"
            type="datetime-local"
            InputLabelProps={{
              shrink: true,
            }}
            value={startDatetime}
            onChange={(e) => setStartDatetime(e?.target?.value)}
            disabled={marginType === 'ASN_DEFAULT'}
          />
        </form>
        <form>
          <TextField
            id="datetime-local2"
            label="End Date & Time"
            type="datetime-local"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ min: startDatetime }}
            value={endDatetime}
            onChange={(e) => setEndDatetime(e?.target?.value)}
            disabled={marginType === 'ASN_DEFAULT'}
          />
        </form>
      </div>
      <div className={styles?.marginTop}>
        <Button variant="contained" color="primary" component="span" onClick={uploadMarginFile}
          disabled={
            !file || (marginType !== 'ASN_DEFAULT' ? !startDatetime || !endDatetime : false)
          }
        >
          Submit
        </Button>
      </div>
      <h5 className={styles?.marginTop}>Margins List</h5>
      <MarginTable
        marginUploadData={marginUploadData}
        reqObj={reqObj}
        totalPageCount={totalPageCount}
        handlePageChange={handlePageChange}
        loader={loader}
      />
    </div>
  )
}

export default MarginUpload;